import React, { useState, useEffect } from 'react';
import { Users, UserPlus, 
  Award, Shield, Clock, CheckCircle, 
  Phone, Mail, MapPin, Send, ArrowRight, Home, BookOpen,
  Brain, Target, Zap, Star, TrendingUp, Globe, Lock,
  FileText, Scale,  Building, Gavel, Heart,
  Baby, UserCheck, Users as FamilyMembers, Shield as Protection,
  Quote, User, UserCheck as UserVerified
} from 'lucide-react';
import WhatsAppIcon from '../components/WhatsAppIcon';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Testimonials = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [hoveredCard, setHoveredCard] = useState(null);
  const [visibleSections, setVisibleSections] = useState({
    hero: false,
    testimonials: false,
    stats: false
  });

  useEffect(() => {
    setIsVisible(true);
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const sectionId = entry.target.getAttribute('data-section');
          if (sectionId) {
            setVisibleSections(prev => ({
              ...prev,
              [sectionId]: true
            }));
          }
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });

    const sections = document.querySelectorAll('[data-section]');
    sections.forEach(section => observer.observe(section));

    return () => {
      sections.forEach(section => observer.unobserve(section));
    };
  }, []);

  const whatsappUrl = "https://wa.me/966115115945";

  const testimonials = [
    {
      id: 2,
      platform: "Google Maps",
      content: "مكتب المحامي انس خياط قدم لي استشاره مميزه عن طريق الواتس بعد ما فهم تفاصيل الموضوع",
      rating: 5,
      platformIcon: "🗺️",
      customerName: "ياسر"
    },
    {
      id: 3,
      platform: "Google Maps",
      content: "أخذت استشارة من عندهم عن طريق الواتساب، كانت مفيدة وساعدتني بالإضافة إلى أنها كانت مجانية.. تعامل رائع بارك الله فيكم ووفقكم المجهود يقدر، كل الشكر ...",
      rating: 5,
      platformIcon: "🗺️",
      customerName: "لطيفة"
    },
    {
      id: 4,
      platform: "Google Maps",
      content: "الله يسعدك يارب ومنها للأعلى ان شاء الله صراحه قمه في الرقي والاحترام المحامي انس ويوصلكم المعلومه بطريقه سلسه وبسيطه ويدعمكم معنوياً قبل اي شي الله يكثر من امثاله انصحكم فيه",
      rating: 5,
      platformIcon: "🗺️",
      customerName: "عارف"
    },
    {
      id: 5,
      platform: "Google Maps",
      content: "الله يعطيك العافيه محامي انس على سعة صدرك و يجزاك بالخير على ما تقدم من مشاركة مجتمعه بتقديم استشارت مجانيه",
      rating: 5,
      platformIcon: "🗺️",
      customerName: "عبدالله"
    },
    {
      id: 6,
      platform: "Google Maps",
      content: "شكرا يا انس ويعطيك الف عافيه",
      rating: 5,
      platformIcon: "🗺️",
      customerName: "خالد"
    },
    {
      id: 7,
      platform: "Google Maps",
      content: "السلام عليكم ورحمة الله ياخوان نرجوا منكم دعم أخونا أنس أقسم بالله أني تواصلت معه وعطاني إستشارة مجانية لوجه الله ومن لا يشكر الناس ما يشكر الله أنشروا حسابه فضلاً وليس أمراً يستاهل كل خير أخونا أنس",
      rating: 5,
      platformIcon: "🗺️",
      customerName: "بدر"
    },
    {
      id: 8,
      platform: "TikTok",
      content: "ماشاء الله تبارك الرحمن .. الله يبارك لك أنس ويرزقك الخير يارب . 💜🙏",
      rating: 5,
      platformIcon: "🎵",
      customerName: "رنيم"
    },
    {
      id: 9,
      platform: "TikTok",
      content: "أخذت استشارة من عندهم، كانت مفيدة جدا وساعدتني بالإضافة إلى أنها كانت مجانية.. تعامل رائع بارك الله فيكم ووفقكم المجهود يُقدّر، كل الشكر 💜✨",
      rating: 5,
      platformIcon: "🎵",
      customerName: "لطيفة"
    },
    {
      id: 10,
      platform: "TikTok",
      content: "أخذت عنده استشارة ما شاء الله محامي شاطر ومتعاون شرح لي كل شي بكل وضوح وأنصح فيه",
      rating: 5,
      platformIcon: "🎵",
      customerName: "نور"
    },
    {
      id: 11,
      platform: "TikTok",
      content: "ماشاء الله تبارك الله نسأل الله لكم التوفيق",
      rating: 5,
      platformIcon: "🎵",
      customerName: "فادي"
    },
    {
      id: 12,
      platform: "TikTok",
      content: "ونعم المحامي أنس خياط من خيرة الرجال الطيبين",
      rating: 5,
      platformIcon: "🎵",
      customerName: "دحمني"
    },
    {
      id: 13,
      platform: "TikTok",
      content: "مرحبا اخوي انس أنعم وأكرم من عائلة كريمة ومرموقة وفقك المولى وسدّدك",
      rating: 5,
      platformIcon: "🎵",
      customerName: "أبو إبراهيم"
    },
    {
      id: 14,
      platform: "Google Maps",
      content: "ما شاء الله تبارك الله، الأستاذ أنس من أميز المحامين اللي تعاملت معهم محامي شاطر ومتعاون جداً طلبت منه استشارة قانونية وما قصر أبداً بل بالعكس أخذ الموضوع بجدية وقال راح يدرسه وفعلاً شرح لي الخطوات اللي أحتاج أسويها بشكل واضح ومفصل أسلوبه راق جداً وأخلاقه عالية، وحتى بعد الاستشارة تابع معي وسأل عن التطورات وهذا شيء نادر بصراحة يشتغل باحترافية عالية وأنصح أي شخص محتار أو يحتاج استشارة قانونية إنه يتوجه له.",
      rating: 5,
      platformIcon: "🗺️",
      customerName: "أريام"
    },
    {
      id: 15,
      platform: "Google Maps",
      content: "انصحكم في التعامل مع المحامي أنس الله يسعده ويرزقه انسان شاطر ولبق ومحترم الله يكثر من امثاله",
      rating: 5,
      platformIcon: "🗺️",
      customerName: "أميرة"
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-100" dir="rtl">
      <Header />
      
      <div 
        data-section="hero"
        className={`relative py-12 sm:py-24 overflow-hidden transition-all duration-1000 mt-16 sm:mt-20 ${visibleSections.hero ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
        style={{ backgroundColor: '#0a3a23' }}
      >
        <div className="absolute inset-0 bg-black opacity-40"></div>
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Ccircle cx='7' cy='7' r='5'/%3E%3Ccircle cx='53' cy='7' r='5'/%3E%3Ccircle cx='30' cy='30' r='5'/%3E%3Ccircle cx='7' cy='53' r='5'/%3E%3Ccircle cx='53' cy='53' r='5'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}></div>
        
        <div className={`relative z-10 max-w-6xl mx-auto px-4 sm:px-6 text-center text-white transition-all duration-1000 delay-300 ${visibleSections.hero ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <div className="mb-4 sm:mb-8">
            <span className="text-white text-lg sm:text-xl animate-pulse">تجارب العملاء</span>
          </div>
          
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-4 sm:mb-6">
            <span className="text-white">تجارب عملائنا</span>
            <div className="w-20 sm:w-32 h-1 bg-white mx-auto mt-2 sm:mt-4 animate-pulse"></div>
          </h1>
          
          <p className="text-base sm:text-lg md:text-xl lg:text-2xl opacity-90 max-w-2xl sm:max-w-4xl mx-auto leading-relaxed mb-4 sm:mb-8 px-4">
            تعرف على تجارب عملائنا في خدماتنا القانونية
          </p>
          <p className="text-sm sm:text-base md:text-lg opacity-80 max-w-xl sm:max-w-3xl mx-auto px-4">
            نفتخر بثقة عملائنا ورضاهم عن خدماتنا القانونية المتميزة
          </p>
        </div>

        <div className="absolute bottom-4 sm:bottom-6 left-1/2 transform -translate-x-1/2 flex items-center gap-1 sm:gap-2 text-white text-xs sm:text-sm">
          <Link to="/" className="flex items-center gap-1 hover:text-gray-200 transition-colors">
            <Home className="w-3 h-3 sm:w-4 sm:h-4" />
            <span>الرئيسية</span>
          </Link>
          <span>/</span>
          <div className="flex items-center gap-1">
            <Users className="w-3 h-3 sm:w-4 sm:h-4" />
            <span>تجارب العملاء</span>
          </div>
        </div>
      </div>

      <div data-section="testimonials" className="py-12 sm:py-20">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className={`text-center mb-12 sm:mb-16 transition-all duration-1000 ${visibleSections.testimonials ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
              تجارب عملائنا
            </h2>
            <p className="text-base sm:text-lg md:text-xl text-gray-600 max-w-2xl sm:max-w-3xl mx-auto px-4">
              تعرف على تجارب عملائنا في خدماتنا القانونية المتميزة
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 [grid-auto-rows:1fr]">
            {testimonials.map((testimonial, index) => (
                             <div
                 key={testimonial.id}
                 className={`bg-white rounded-xl sm:rounded-2xl shadow-lg hover:shadow-xl transition-all duration-500 p-6 sm:p-8 h-full flex flex-col ${visibleSections.testimonials ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
                 style={{ transitionDelay: `${index * 200}ms` }}
                 onMouseEnter={() => setHoveredCard(testimonial.id)}
                 onMouseLeave={() => setHoveredCard(null)}
               >
                 {/* الهيدر */}
                 <div className="flex items-center gap-4 mb-6">
                   <div className="w-16 h-16 rounded-full bg-gradient-to-r from-[#0a3a23] to-[#0a3a23] flex items-center justify-center">
                     <span className="text-2xl">{testimonial.platformIcon}</span>
                   </div>
                   <div>
                     <h3 className="text-lg font-bold text-gray-900">{testimonial.platform}</h3>
                   </div>
                 </div>

                 {/* النجوم */}
                 <div className="flex items-center gap-1 mb-4">
                   {[...Array(testimonial.rating)].map((_, i) => (
                     <Star key={i} className="w-5 h-5" style={{ color: '#0a3a23' }} fill="currentColor" />
                   ))}
                 </div>

                 {/* النص: ارتفاع أدنى + كلّامب لعدد أسطر موحّد */}
                 <div className="flex-1">
                   <p className="text-gray-700 leading-relaxed mb-6 min-h-28 sm:min-h-32 md:min-h-36 lg:min-h-40 line-clamp-5">
                     "{testimonial.content}"
                   </p>
                 </div>

                 {/* الأيقونة + الاسم */}
                 <div className="flex items-center justify-between mt-auto">
                   <div className="w-8 h-8 rounded-full flex items-center justify-center" style={{ backgroundColor: 'rgba(10, 58, 35, 0.1)' }}>
                     <Quote className="w-4 h-4" style={{ color: '#0a3a23' }} />
                   </div>
                   <div className="text-sm text-gray-500">
                     {testimonial.customerName}
                   </div>
                 </div>
               </div>
            ))}
          </div>
        </div>
      </div>

      <div className="py-12 sm:py-16">
        <div className="max-w-4xl mx-auto text-center px-4 sm:px-6">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-4 sm:mb-6">
            انضم إلى عملائنا الراضين
          </h2>
          <p className="text-base sm:text-lg text-gray-600 mb-6 sm:mb-8">
            تواصل معنا الآن للحصول على خدمات قانونية متميزة
          </p>
          
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center">
            <a
              href={`${whatsappUrl}?text=أريد استشارة قانونية`}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 sm:gap-3 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-xl font-bold text-base sm:text-lg transition-all duration-300 shadow-lg hover:shadow-xl w-full sm:w-auto"
              style={{ backgroundColor: '#0a3a23' }}
            >
              <WhatsAppIcon className="w-5 h-5 sm:w-6 sm:h-6" />
              تواصل عبر الواتساب
            </a>
            <Link
              to="/Contact"
              className="inline-flex items-center gap-2 sm:gap-3 bg-gray-800 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-xl font-bold text-base sm:text-lg hover:bg-gray-900 transition-all duration-300 shadow-lg hover:shadow-xl w-full sm:w-auto"
            >
              <Send className="w-5 h-5 sm:w-6 sm:h-6" />
              تواصل معنا
            </Link>
          </div>
        </div>
      </div>

      <a
        href="tel:920033053"
        className="fixed bottom-20 sm:bottom-28 left-4 sm:left-6 bg-gradient-to-r from-[#0a3a23] to-[#0a3a23] text-white p-3 sm:p-4 rounded-full shadow-2xl hover:shadow-[#0a3a23]/25 transition-all duration-300 z-50 hover:scale-110"
      >
        <Phone className="w-5 h-5 sm:w-6 sm:h-6" />
      </a>

      <a
        href={`${whatsappUrl}?text=أريد استشارة قانونية`}
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-4 sm:bottom-6 left-4 sm:left-6 bg-gradient-to-r from-[#0a3a23] to-[#0a3a23] text-white p-3 sm:p-4 rounded-full shadow-2xl hover:shadow-[#0a3a23]/25 transition-all duration-300 z-50 hover:scale-110"
      >
        <WhatsAppIcon className="w-5 h-5 sm:w-6 sm:h-6" />
      </a>

      <Footer />
    </div>
  );
};

export default Testimonials; 
